import { isEqualValue, isMinChar, isRequired } from '../../../utils/validation';

export const initialValues = {
  password: '',
  confirmPassword: '',
};

export const fieldsProps = {
  password: {
    placeholder: 'Password',
    label: 'Password',
    type: 'password',
    description:
      'Gunakan gabungan karakter huruf, angka & simbol untuk password yang lebih baik',
  },
  confirmPassword: {
    placeholder: 'Password',
    label: 'Konfirmasi Password',
  },
};

export const validate = (values) => {
  const { password, confirmPassword } = values;
  const rules = {
    password:
      isRequired(password, 'Kata Sandi harus diisi') ||
      isMinChar(6, password, 'Password minimal 6 karakter'),
    confirmPassword:
      isRequired(confirmPassword, 'Konfirmasi Kata Sandi harus diisi') ||
      isEqualValue(confirmPassword, password, 'Konfirmasi Password tidak sama'),
  };

  return rules;
};
